export default "__VITE_ASSET__BxN55fD9__"